import type { InjectionKey, Ref } from "vue";

import type { Shape } from "@/model/shape";

export const shapeKey: InjectionKey<Readonly<Ref<Shape | undefined>>> = Symbol("shape");
